// extracted by mini-css-extract-plugin
export default {"error-page":"Following_error-page__pI2h1","error-image":"Following_error-image__5g4t9"};